import React from 'react';
import styled from 'styled-components';
import {Btn} from './Btn';
import ColorVariables from '../../variables/ColorVariables.js';
import SpaceVariables from '../../variables/SpaceVariables.js';

const ConfirmTool = React.forwardRef(({setClicked, onClick, t, ...rest}, ref) => (
    <Wrapper ref={ref} {...rest}>
        <ToolTipTitle>{t('customer.DeleteExtraWork')}</ToolTipTitle>
        <Btn
            ghost
            color="danger"
            onClick={() => {
                setClicked(false);
            }}
            type="button"
        >
            {t('general.Cancel')}
        </Btn>

        <Btn ghost color="blank" onClick={() => onClick()} type="button">
            {t('general.Confirm')}
        </Btn>
    </Wrapper>
));

ConfirmTool.displayName = 'Tooltip';

const Wrapper = styled.div`
    ${ColorVariables}
    ${SpaceVariables}
    z-index: 9000;
    position: absolute;
    background-color: #dc3545de !important;
    color: white;
    padding: 8px 12px;
    --arrow-height: 8px;
    margin-top: var(--arrow-height);
    margin: 0px;
    box-shadow: -2px -2px 2px 0px #28368205, 1px 1px 1px -3px #102c4954;
    border-radius: 4px;
    width: 240px;

    ${Btn} {
        background: none;
        border: 1px solid var(--blank);
        color: var(--blank);
        &:hover {
            background: none;
            border: 1px solid var(--danger-02);
            color: var(--danger-02);
            transition: 0.6s;
        }
    }
`;

const ToolTipTitle = styled.div`
    text-transform: uppcase;
    margin-bottom: 6px;
    b,
    label {
        font-size: 8px;
    }
`;

export default ConfirmTool;
